import { useOutletContext } from "react-router-dom";

import CompletedProductionsView from "../views/CompletedProductions/CompletedProductionsView";

export default function CompletedProductions() {
	const { organization } = useOutletContext();

	return <CompletedProductionsView organization={organization} />;
}
